

  import {Component, Vue} from 'vue-property-decorator';
  import {Prop} from "vue-property-decorator";
  import RechnungService from '../../../services/rechnung.service'
  import LoadingOverlay from "../../core/LoadingOverlay.vue";


  @Component({
    components: {LoadingOverlay},
  })
  export default class RechnungDeleteDialog extends Vue {

    @Prop({default: null})
    selectedRechnung: any;

    private showOverlay = false;

    deleteRechnung() {
      this.showOverlay = true;
      RechnungService.deleteRechnung(this.selectedRechnung.id)
        .then(
          (response: any) => {
            this.$notify({
              group: 'foo',
              title: 'Info',
              text: response.data,
              type: 'success'
            });
            this.showOverlay = false;
            this.$emit('event', this.selectedRechnung.vendor.id);
          })
        .catch((error: any) => {
          this.$notify({
            group: 'foo',
            title: 'Fehler',
            text: error,
            type: 'error'
          });
        })
        .finally(() => {
          setTimeout(() => {
            this.showOverlay = false;
          }, 5000);
        });
    }
  }
